import { Link } from 'react-router-dom';

function CourseModules() {
  const modules = [
    {
      id: 1,
      title: 'Fundamentos de Anatomía Funcional y Biomecánica',
      description: 'Planos, ejes, palancas, torque y biomecánica aplicada a ejercicios fundamentales.',
      icon: 'ri-body-scan-line',
      lessons: 6,
      color: 'from-[#39FF14] to-[#2ecc40]',
      link: '/module1'
    },
    {
      id: 2,
      title: 'Fisiología del Ejercicio y Adaptaciones',
      description: 'Sistemas energéticos, reclutamiento motor, fatiga, mecanismos de hipertrofia y recuperación.',
      icon: 'ri-heart-pulse-line',
      lessons: 5,
      color: 'from-[#2ecc40] to-[#27ae60]',
      link: '/module2'
    },
    {
      id: 3,
      title: 'Metodologías de Entrenamiento',
      description: 'Análisis completo de sistemas: Weider, Heavy Duty, HIT, PPL, Full Body, Upper Lower y periodización.',
      icon: 'ri-calendar-schedule-line',
      lessons: 9,
      color: 'from-[#27ae60] to-[#229954]',
      link: '/module3'
    },
    {
      id: 4,
      title: 'Entrenamiento de Alta Intensidad y HIIT',
      description: 'HIIT real vs cardio fraccionado, protocolos validados (Tabata, Wingate, EMOM, AMRAP) y aplicación segura.',
      icon: 'ri-flashlight-line',
      lessons: 9,
      color: 'from-[#229954] to-[#1e8449]',
      link: '/module4'
    },
    {
      id: 5,
      title: 'Fuerza, Hipertrofia y Rendimiento',
      description: 'Rangos de repeticiones, intensidad, RPE, RIR, fallo muscular, tempo y técnicas de intensidad avanzadas.',
      icon: 'ri-file-chart-line',
      lessons: 6,
      color: 'from-[#1e8449] to-[#196f3d]',
      link: '/module5'
    },
    {
      id: 6,
      title: 'Movilidad, Estiramientos y Prevención de Lesiones',
      description: 'Movilidad vs flexibilidad, estiramientos, activación neuromuscular y prevención de lesiones comunes.',
      icon: 'ri-heart-pulse-line',
      lessons: 9,
      color: 'from-[#196f3d] to-[#145a32]',
      link: '/module6'
    },
    {
      id: 7,
      title: 'Nutrición Deportiva Aplicada',
      description: 'Macronutrientes, balance energético, síntesis proteica y suplementación basada en evidencia científica.',
      icon: 'ri-restaurant-2-line',
      lessons: 10,
      color: 'from-[#145a32] to-[#0e4b28]',
      link: '/module7'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Módulos del Curso
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Formación progresiva desde fundamentos hasta aplicación avanzada. Cada módulo construye sobre el anterior.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {modules.map((module) => (
            <Link
              key={module.id}
              to={module.link}
              className="group bg-white rounded-xl border-2 border-gray-200 hover:border-[#39FF14] transition-all duration-300 overflow-hidden hover:shadow-xl"
            >
              <div className={`bg-gradient-to-br ${module.color} p-6`}>
                <div className="flex items-center justify-between mb-4">
                  <div className="w-14 h-14 bg-white/20 backdrop-blur-sm rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className={`${module.icon} text-3xl text-white`}></i>
                  </div>
                  <span className="text-white/90 text-sm font-semibold">
                    Módulo {module.id}
                  </span>
                </div>
                <h3 className="text-xl font-bold text-white mb-2 leading-tight">
                  {module.title}
                </h3>
              </div>
              
              <div className="p-6">
                <p className="text-gray-600 text-sm leading-relaxed mb-4">
                  {module.description}
                </p>
                
                <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                  <div className="flex items-center gap-2 text-gray-500 text-sm">
                    <i className="ri-book-open-line"></i>
                    <span>{module.lessons} lecciones</span>
                  </div>
                  <div className="flex items-center gap-2 text-[#39FF14] font-semibold text-sm group-hover:gap-3 transition-all">
                    <span>Acceder</span>
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export default CourseModules;
